export default "__VITE_ASSET__CdTGnynV__"